import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, computed, inject, Input, signal } from '@angular/core';
import { Profile } from '../../../shared/entities/Profile/Profile';
import { LanguageLevel } from '../../../shared/entities/Profile/LanguageLevel';
import { GraduationType } from '../../../shared/entities/Profile/GraduationType';
import { ProfileAttachment } from '../../../shared/entities/Profile/ProfileAttachment';

@Component({
  selector: 'app-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrl: './profile-details.component.scss'
})
export class ProfileDetailsComponent {
  LanguageLevel = LanguageLevel;
  GraduationType = GraduationType;
  http = inject(HttpClient);


  @Input({ required: true }) profile = signal<Profile | undefined>(undefined);
  @Input() attachments = signal<ProfileAttachment[] | undefined>(undefined);
  @Input() relevance: number | undefined = (undefined);
  cermitLink= computed(() => 'cermit:person/'+this.profile()!.ceRMitId);
  resume = computed(() => this.profile()?.extractedResume ?? undefined);
  resumeProjects = computed(() => this.resume()?.projects ?? undefined);
  resumeLanguages = computed(() => this.resume()?.languages ?? undefined);
  resumeAchievements = computed(() => this.resume()?.achievements ?? undefined);
  resumeGraduations = computed(() => this.resume()?.graduations ?? undefined);

  resumeRoles = computed(() => {
    const res = this.resume()?.roles ?? undefined;
    if (res === undefined) {
      return [];
    }
    return res.map((role) => {
      if (role.monthsOfExperience === undefined) {
        role.monthsOfExperience = 0;
      }
      return role.name + ' (' + role.monthsOfExperience + ' months)';
    });
  });

  resumeSkills = computed(() => {
    const res = this.resume()?.skills ?? undefined;
    if (res === undefined) {
      return [];
    }
    return res.map((skill) => {
      if (skill.monthsOfExperience === undefined) {
        skill.monthsOfExperience = 0;
      }
      return skill.name + ' (' + skill.monthsOfExperience + ' months)';
    });
  });

  downloadAttachment(attachment: ProfileAttachment): void {
    const url = `{uri}/profiles/${attachment.ceRMitId}/attachments/${attachment.id}`;

    // ToDo should we do this here?
    this.http
      .get(url, { observe: 'response', responseType: 'blob' })
      .subscribe((res) => {
        const fileName = this.getFileName(res.headers) ?? `${attachment.originalFileName ?? "unknown.pdf"}`;
        const file = new Blob([res.body!], { type: res.headers.get('Content-Type')! });
        const element = document.createElement('a');
        element.href = URL.createObjectURL(file);
        element.download = fileName;
        document.body.appendChild(element);
        element.click();
      });
  }

  // ToDo: This is copy pasted from base-data.service.ts. 
  // move this to extension method and/or remove the download from this class.
  private getFileName(headers: HttpHeaders): string | null {

    const disposition = headers.get('Content-Disposition') ?? "";
    if (disposition && disposition.indexOf('attachment') === -1) {
      return null;
    }

    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      return matches[1].replace(/['"]/g, '');
    }

    return null;
  }
}
